var render = function render(_c,_vm){return _c('div',{staticClass:"verify-step3"},[_c('mm-icon',{attrs:{"name":"success","size":"80px"}}),_c('p',{directives:[{name:"t",rawName:"v-t",value:('auth.success'),expression:"'auth.success'"}],staticClass:"tips"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }